<uppy-dashboard [uppy]="uppy" [props]="uppyDashboardOptions"></uppy-dashboard>
<div class="upload-file-dialog-footer">
  <button
    mat-flat-button
    color="primary"
    (click)="closeDialog()"
  >OK</button>
</div>